import Service from './service';
import { AxiosResponse } from 'axios';
const Config = require('Config');

export interface TemplateEmailBody {
  to: string | string[],
  cc?: string | string[],
  bcc?: string | string[],
  from: string | string[],
  subject?: string,
  templateId: string,
  dynamicTemplateData: Record<string, unknown>
}

class EmailService extends Service {
  constructor() {
    super(Config.emailServiceUrl);
  }

  async sendTemplateEmail(body?: TemplateEmailBody): Promise<Array<string>> {
    const url = '/template';

    const response: AxiosResponse = await this.axios.post(url, body);
    if (!response || response.status < 200 || response.status > 300 ) {
      throw new Error();
    }
    return response.data;
  }
}

export const emailService = new EmailService();
